export const ROUTERJUMPUNMOUNTCOMPONENT = Symbol('routerJumpUnmountComponent')
